import { render, staticRenderFns } from "./WomanBody.vue?vue&type=template&id=61c11c44&scoped=true&"
import script from "./WomanBody.vue?vue&type=script&lang=js&"
export * from "./WomanBody.vue?vue&type=script&lang=js&"
import style0 from "./WomanBody.vue?vue&type=style&index=0&id=61c11c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c11c44",
  null
  
)

export default component.exports